<template>
  <v-row justify="center" v-if="plan_inscripcion && programa">
    <v-dialog v-model="dialog" persistent scrollable width="auto" :fullscreen="$vuetify.breakpoint.mobile">
      <v-card>
        <v-toolbar dark dense flat class="max-height">
          <v-spacer></v-spacer>
          <v-toolbar-title class="white--text"> Aprobar el plan de pagos</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <p class="mb-0 text-center black--text h4">{{ programa.nombre_compuesto }}</p>
          <v-row>
            <v-card-subtitle primary-title class="mb-0 pb-0">
              <p class="my-0 py-0">Revisar que la inscripcion se encuentre en el plan correcto.</p>
              <p class="my-0 py-0">
                <span class="font-weight-bold red--text">NOTA:</span> esta ventana solo aparece una sola vez por estudiante durante el primer pago, usted sera
                el responsable de aprobarlo que este estudiante esta en el plan correcto
              </p>
              <p v-if="existRecibo" class="red--text font-weight-bold">AVISO: Esta Inscripcion ya tiene recibos generados, solo queda aprobarlo el plan</p>
            </v-card-subtitle>
            <v-col md="6" sm="12" class="py-0">
              <v-data-table :headers="headers" :items="plan_inscripcion.cobros" hide-default-footer disable-pagination class="elevation-10">
                <template v-slot:top>
                  <p class="h3 text-center pt-2 text-primary">{{ plan_inscripcion.nombre }}</p>
                </template>
              </v-data-table>
            </v-col>
            <v-col md="6" sm="12" class="py-0">
              <v-data-table
                :headers="headersItems"
                :items="plan_pagos"
                hide-default-footer
                disable-pagination
                class="elevation-10"
                :item-class="itemRowBackgroundMora"
              >
                <template v-slot:top>
                  <p class="h3 text-center pt-2 text-primary">Cuotas de Plan De Pagos</p>
                </template>
                <template v-slot:no-data>
                  <div role="listbox" tabindex="-1" class="v-list v-select-list v-sheet theme--light v-list--dense theme--light">
                    <div tabindex="-1" class="v-list-item theme--light">
                      <div class="v-list-item__content">
                        <div class="v-list-item__title font-weight-bold red--text">El Estudiante no tiene plan de pagos</div>
                      </div>
                    </div>
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text> 
        <v-divider></v-divider>
        <v-card-actions>
          <v-progress-linear heigth="2" indeterminate v-if="verificando_netsuite" />
          <v-spacer></v-spacer> 
          <template v-if="plan_pagos.length > 0">
            <!-- <v-btn v-if="!existRecibo" color="info" rounded small @click="eliminarPlan"> <v-icon class="mr-1"> mdi-change</v-icon> Eliminar de plan </v-btn> -->
            <v-btn v-show="!verificando_netsuite && comprobar_netsuite" color="orange" @click="enviarANetsuite()" rounded small dark> <v-icon class="mr-1" small left> mdi-send</v-icon> Enviar Netsuite </v-btn>
            
            <v-btn v-show="!verificando_netsuite && !comprobar_netsuite" v-if="!existRecibo" color="info" rounded small @click="generatePlan(true)"> <v-icon class="mr-1">mdi-sync</v-icon> Cambiar de plan </v-btn>
            <v-btn v-show="!verificando_netsuite && !comprobar_netsuite" color="success" @click="aprobarPlan" rounded small> <v-icon class="mr-1"> mdi-content-save</v-icon> Aprobar Plan de Pagos </v-btn>
          </template>
          <template v-else>
            <v-btn v-show="!verificando_netsuite && !comprobar_netsuite" color="amber" rounded small @click="generatePlan(false)"> <v-icon class="mr-1"> mdi-change</v-icon> Generar un Plan de Pagos </v-btn>
          </template>
          <v-btn color="blue darken-1" outlined rounded small @click="cancel"> Cancelar <v-icon> mdi-close</v-icon> </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MandarNetSuite ref="refMandarNetsuite" v-on:success="successNetSuite" />
  </v-row>
</template>

<script>
import xaxios from '@/xaxios';
import MandarNetSuite from '@/components/Programa-insNetsuite.vue';

export default {
  props: ['programa', 'existRecibo'],
  components:{ MandarNetSuite },
  data() {
    return {
      dialog: false,
      api_rest: process.env.VUE_APP_API_REST,
      plan_inscripcion: null,
      plan_pagos: [],
      verificando_netsuite: false,
      comprobar_netsuite: null,

      headers: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Monto', value: 'monto' },
        { text: 'Cuotas', value: 'cuotas' },
      ],
      headersItems: [
        // { text: 'id', value: 'id', sortable: false },
        { text: 'Concepto de pago', value: 'concepto' },
        { text: 'N° de Cuota', value: 'numero_cuota' },
        { text: 'Monto', value: 'monto' },
        { text: 'Saldo', value: 'saldo' },
        { text: 'Fecha Pago', value: 'date_pago' },
      ],
      thiz_padre: {},
    };
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
  },
  methods: {
    showThisView(plan_inscripcion, plan_pagos = [],thiz_padre={}) {
      this.dialog = true;
      this.plan_inscripcion = plan_inscripcion;
      this.plan_pagos = plan_pagos.sort((a, b) => a.id - b.id);
      this.thiz_padre = thiz_padre;
      this.iniciarForNetSuite();
    },
    aprobarPlan() {
      const url = `${this.api_rest}/api/esam/inscripcion/plan/aprobar`;
      xaxios
        .post(url, { inscripcion_id: this.programa.id, user_id: this.$store.state.DATA_USER.id })
        .then(() => {
          this.closeDialog();
          this.$emit('clickedAprobe', { estado_plan_id: true, aprobado_plan_user_id: this.$store.state.DATA_USER.id });
        })
        .catch(({ response: { data } }) => this.$root.$notify.show(`${data.error}`, { color: 'danger' }));
    },
    cancel() {
      this.$root.$notify.show(`${this.plan_inscripcion.nombre}, No fue aprobado para esta inscripcion, por tanto nose puede emitir recibo`, {
        color: 'red',
        timeout: 5000,
      });
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
      this.plan_inscripcion = null;
      this.plan_pagos = [];
    },
    generatePlan(value) {
      if(value){
        const idsede = this.$store.state.CARGO.sede.id 
        const contiene_avd = this.programa.nombre_compuesto.includes('U301 AVANZADO)')
        window.console.log('contiene_avd', contiene_avd);
        
        if(idsede == 82 && contiene_avd ){
          const u = `/generar_plan_upi/${this.programa.programa_id}?ins_id=${this.programa.id}&asesor_id=${this.programa.asesor_id}&doc=${this.thiz_padre.persona.num_doc}&cambio_plan=true`;
          this.$router.push(u);
          return;
        }
      }
      
      this.$store.dispatch('inscripcion/selectInscripcion', {id:this.programa.id});
      let programa = Object.assign(
        {
          programa: { id: this.programa.programa_id },
          estudiante: { id: this.programa.estudiante_id },
          asesor: { id: this.programa.asesor_id },
        },
        this.programa
      );
      
      window.sessionStorage.setItem('xinscritotoplan', JSON.stringify(programa));
      window.sessionStorage.setItem(
        'xprograma',
        JSON.stringify({ id: programa.programa_id, codigo: programa.nombre_compuesto, inscripcion_id: this.programa.id, plan_pagos: this.plan_pagos, estudiante_id:this.programa.estudiante_id })
      );
      value ? this.$router.push({ name: 'inscripcionrest' }) : this.$router.push({ name: 'regularizar' });
    },
    eliminarPlan() {
      const url = `${this.api_rest}/api/esam/inscripcion/plan/eliminar`;
      xaxios
        .post(url, { inscripcion_id: this.programa.id })
        .then(() => {
          this.plan_pagos = [];
          this.$emit('deletePlan', true);
          this.$root.$notify.show(`${'Plan de Pagos  Eliminado del estudiante. Debe generar uno nuevo'}`, { color: 'info' });
        })
        .catch(({ response: { data } }) => this.$root.$notify.show(`${data.error}`, { color: 'danger' }));
    },
    itemRowBackgroundMora(item) {
      let fecha_pago = new Date(item.fecha_pago);
      fecha_pago.setDate(fecha_pago.getDate() + 1);

      let fecha_mes = new Date(item.fecha_pago);
      fecha_mes.setMonth(fecha_mes.getMonth() + 1);

      if (fecha_mes < new Date() && item.saldo != 0) return 'mora-mes-1';
      if (fecha_pago < new Date() && item.saldo != 0) return 'mora-semana-1';
      return item.saldo_regularizado ? 'regularizado' : '';
    },
    async iniciarForNetSuite(){
      let unidad = this.$store.state.CARGO.sede.unidad_negocio;
      // window.console.log('unidaddadad', unidad);
      // if(!this.$store.state.NETSUITE_VISIBLE){
      if( unidad == 6){
        this.comprobar_netsuite = null;
        return;
      }
      this.verificando_netsuite = true; 
      this.comprobar_netsuite = null;
      
      const url2 = `${this.api_rest}/esam/persona/id/${this.thiz_padre.persona.id}`;
      let res2 = await xaxios.get(url2).then(({data})=>data).catch(e=>e);
      this.thiz_padre.zestudent = res2.persona;
      this.thiz_padre.zestudent.pri_apellido = res2.persona.primer_apellido;
      this.thiz_padre.zestudent.seg_apellido = res2.persona.segundo_apellido;
      this.thiz_padre.zestudent.num_doc = res2.persona.numero_documento;
      this.thiz_padre.zestudent.email = res2.persona.email;
      this.verificando_netsuite = false;
      
      let sede = this.$store.state.CARGO.sede; 
      window.console.log('res:::>', this.thiz_padre,res2,sede); 
      if( !res2.persona.cliente_netsuite_id && sede.subsidiaria_id){
        this.comprobar_netsuite = {
          subsidiaria: sede.subsidiaria,
          subsidiaria_id: sede.subsidiaria_id,
          ubicacion: sede.ubicacion,
          ubicacion_id: sede.ubicacion_id, 
        }
      }
      if(!sede.subsidiaria_id){
        this.$root.$notify.show('La sede no tiene subsidiaria netsuite', {color:'red',x: 'right',});
      }
      this.comprobando_netsuite = res2.persona.cliente_netsuite_id != undefined;
    },
    enviarANetsuite(){
      let idsedeprog = this.thiz_padre.programa.sede_id;
      let sede = this.$store.state.CARGOS.find(c=>c.idsede==idsedeprog);
      // window.console.log('this.comprobar_netsuite',this.comprobar_netsuite);
      // window.console.log('<><><><><><><>', this);
      const customdata = {
        estudiante_id: this.thiz_padre.programa.estudiante_id,
        postragrado_id: this.thiz_padre.programa.posgrado_id,
        sede: {...sede.sede}
      }
      this.$refs.refMandarNetsuite.openInsNet(this.thiz_padre.zestudent,customdata,false);
    },
    successNetSuite(res){
      if(res == 'success'){
        this.comprobar_netsuite = null;
      }
    },
  },
};
</script>
<style>
.max-height {
  max-height: 4.5em;
}
.mora-mes-1 {
  background-color: #fb706d78;
}
.mora-semana-1 {
  background-color: #ffe17694;
}
.regularizado {
  background-color: #0076fb5e;
}
</style>
